import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Reporting: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10 2.4H3.33333V13.6H12.6667V5.2H10V2.4ZM2 1.69426C2 1.31084 2.29833 1 2.66567 1H10.6667L13.9998 4.5L14 14.2948C14 14.6842 13.7034 15 13.3377 15H2.66227C2.29651 15 2 14.6813 2 14.3057V1.69426ZM8 5.2V8H10.6667C10.6667 9.54637 9.47273 10.8 8 10.8C6.52724 10.8 5.33333 9.54637 5.33333 8C5.33333 6.4536 6.52724 5.2 8 5.2Z"
        fill={color}
      />
    </svg>
  );
};

export default Reporting;
